import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
export const loginPath = () => (localStorage.getItem("bw_login_slug") ? `/login/${localStorage.getItem("bw_login_slug")}` : "/login");

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config || {};
    const url = orig.url || "";
    if (error.response?.status === 401 && !orig._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
        if (window.location.pathname.startsWith("/app")) {
          window.location.assign(`${loginPath()}?expired=1`);
          return new Promise(() => {});
        }
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}
